import jwtDecode from 'jwt-decode';
import { token as localStorageToken } from 'Utils/envLoader';

const getUser = (token) => {
    try {
        const jwt = token ? token : localStorage.getItem(localStorageToken);
        if (jwt !== null) {
            const userDecoded = jwtDecode(jwt);
            userDecoded.userData = JSON.parse(userDecoded?.userData);
            // console.log(userDecoded);
            return userDecoded;
        }
        return null;
    } catch (ex) {
        return null;
    }
};

export default getUser;
